
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Rheostat, { PublicState } from 'rheostat';
import 'rheostat/css/slider.css';
import 'rheostat/css/slider-horizontal.css';

import { TextInput } from '../../components/forms';
import { Button } from '../../components/buttons';
import Utils from '../../common/utils';

import policyActions from '../../policy/policyActions';

interface Props {
	customerPolicy: CustomerPolicy;
	beneficiaries: CustomerPolicyBeneficiaryDto[];
	typedBeneficiaries: CustomerPolicyBeneficiaryDto[];
	history: any;
	match: any;
	actions: any;
}

interface RheostatPitProps {
	style?: {};
	children?: {};
}

const RheostatPit: React.StatelessComponent<RheostatPitProps> = ({ style, children }) => {
	return (
		<div className="rheostat-pit" style={style}>
			{children}
		</div>
	);
};

class CustomerBeneficiariesDisbursementRow extends React.Component<Props> {
	constructor(props: any) {
		super(props);
	}

	onDisbursementChange = (e: any, beneficiary: CustomerPolicyBeneficiaryDto) => {
		if (e.target.value > 100) {
			return;
		}

		const value = Math.min(100, e.target.value);
		const valuePct = value / 100;
		const newBeneficiary = {
			...beneficiary,
			[e.target.name]: valuePct
		};
		this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
	}
	onValuesUpdated = (publicState: PublicState, beneficiary: CustomerPolicyBeneficiaryDto) => {
		// Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
		const valuePct = publicState.values[0] / 100;
		const newBeneficiary = {
			...beneficiary,
			disbursementPercent: valuePct
		};

		this.props.actions.setCustomerPolicyBeneficiary(newBeneficiary);
	}

	disburseEqually = () => {
		const numBeneficiaries = this.props.typedBeneficiaries.length;
		const typeIndetifier = this.props.typedBeneficiaries[0].typeId;
		const beneficiaries = this.props.beneficiaries.map(beneficiary => {
			return beneficiary.typeId === typeIndetifier ? {
				...beneficiary,
					disbursementPercent: 1 / numBeneficiaries
			} : {
				...beneficiary
			};
		});

		this.props.actions.setCustomerPolicyBeneficiaries(beneficiaries);
	}

	getTotal = () => {
		const total = this.props.typedBeneficiaries.reduce((a, b) => a + parseFloat((b.disbursementPercent as any) || 0), 0);
		return total;
	}

	render() {
		const title = Utils.getPickListItemDescription(this.props.typedBeneficiaries[0].typeId);
		return (
			<div className="form-fieldset content-set">
							<div className="customer-dashboard-plan-info">
								<strong className="d-inline large">
									{title}
								</strong>
								{this.props.typedBeneficiaries.length > 0 && (
									<div className="d-inline text-right">
										<Button className="btn-outline-secondary btn-sm" onClick={this.disburseEqually}>
											Disburse equally
									</Button>
									</div>
								)}
							</div>
							{this.props.typedBeneficiaries.length > 0 ? (
								<div className="beneficiaries-disbursement">
									{this.props.typedBeneficiaries.map(beneficiary => (
										<div className="beneficiary-disbursement-item" key={beneficiary.id}>
											<div className="row align-items-center">
												<div className="col-md-3 col-lg-2 mb-4 mb-md-0">
													<strong className="beneficiary-name">{beneficiary.name}</strong>
												</div>
												<div className="col-md-6 col-lg-8 mb-4 mb-md-0">
													<Rheostat
														onValuesUpdated={publicState => this.onValuesUpdated(publicState, beneficiary)}
														orientation="horizontal"
														pitComponent={RheostatPit}
														pitPoints={[25, 50, 75]}
														snap={true}
														values={[(beneficiary.disbursementPercent || 0) * 100]}
													/>
												</div>
												<div className="col-md-3 col-lg-2">
													<TextInput
														name="disbursementPercent"
														id={`disbursement-${beneficiary.id}`}
														value={Math.trunc((beneficiary.disbursementPercent || 0) * 100)}
														onChange={e => this.onDisbursementChange(e, beneficiary)}
														addOnAfter="%"
														className="mb-0"
													/>
												</div>
											</div>
										</div>
									))}
									<div className="row mt-4">
										<div className="col-md-10 text-md-right">
											<span className="large">Total (must be 100%):</span>
										</div>
										<div className="col-md-2">
											<strong className="large">{Math.round(this.getTotal() * 100)}%</strong>
										</div>
									</div>
								</div>
							) : (
									<em className="reduced-em">No beneficiaries</em>
								)}
						</div>

		);
}
}
function mapStateToProps(state: any, props: Props) {
	return {
		customerPolicy: state.policy.customerPolicy,
		beneficiaries: state.policy.beneficiaries.pending,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerBeneficiariesDisbursementRow);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerBeneficiariesDisbursementRow.tsx